import { createIcon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const DiscordFill: (props: IconProps) => JSX.Element = createIcon({
  displayName: `DiscordFill`,
  viewBox: `0 0 24 24`,
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.289 5.81904C17.9093 5.19395 16.4527 4.7505 14.9565 4.5C14.7518 4.86219 14.5666 5.23482 14.4016 5.61636C12.8078 5.37871 11.1871 5.37871 9.59341 5.61636C9.42833 5.23486 9.24308 4.86223 9.03843 4.5C7.54129 4.75261 6.08378 5.19712 4.70267 5.82231C1.96081 9.83663 1.21754 13.7512 1.58918 17.6103C3.19488 18.7843 4.99211 19.6771 6.90276 20.25C7.33298 19.6774 7.71367 19.0699 8.04079 18.4341C7.41947 18.2044 6.81978 17.9211 6.24868 17.5874C6.39898 17.4795 6.54599 17.3684 6.68803 17.2605C10.0526 18.8263 13.9473 18.8263 17.3119 17.2605C17.4556 17.3766 17.6026 17.4877 17.7512 17.5874C17.179 17.9217 16.5783 18.2055 15.9558 18.4357C16.2826 19.0713 16.6633 19.6782 17.0939 20.25C19.0061 19.6794 20.8048 18.787 22.4107 17.6119C22.8468 13.1367 21.6658 9.25802 19.289 5.81904ZM8.51153 15.237C7.4759 15.237 6.62031 14.307 6.62031 13.1628C6.62031 12.0187 7.44617 11.0805 8.50823 11.0805C9.57028 11.0805 10.4193 12.0187 10.4011 13.1628C10.3829 14.307 9.56698 15.237 8.51153 15.237ZM13.5988 13.1628C13.5988 14.307 14.4511 15.237 15.4884 15.237C16.5438 15.237 17.3581 14.307 17.3763 13.1628C17.3945 12.0187 16.5521 11.0805 15.4884 11.0805C14.4247 11.0805 13.5988 12.0187 13.5988 13.1628Z"
      fill="currentColor"
    />
  ),
  defaultProps: {
    width: `100%`,
    height: `100%`,
    fill: `none`,
  },
});

export default DiscordFill;
